export default __webpack_public_path__ + "static/media/Accordion-down.4599fc3b.svg";